<template>
  <a-modal
    v-model:visible="initState.visible"
    title="总频次控制"
    width="800px"
    :footer="null"
  >
    <a-form layout="inline">
      <a-form-item label="间隔天数">
        <a-input-number
          v-model:value="state.intervalDays"
          :min="1"
          :max="99"
          :precision="0"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="弹出次数">
        <a-input-number
          v-model:value="state.popupCount"
          :min="1"
          :max="99"
          :precision="0"
        ></a-input-number>
      </a-form-item>
      <a-button type="primary" @click="onOk">确定</a-button>
    </a-form>
    <div style="margin: 20px 0">
      历史记录
    </div>
    <a-table
      :columns="columns"
      :dataSource="state.dataSource"
      bordered
      :pagination="false"
      rowKey="id"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'ruleIdList'">
          {{ record.ruleIdList.join(',') }}
        </template>
      </template>
    </a-table>
    <div class="pagination">
      <a-pagination
        :showTotal="total => `共 ${total}条数据`"
        v-model:current="state.pagination.pageNum"
        v-model:pageSize="state.pagination.pageSize"
        :total="state.pagination.total"
        @change="getMainPage"
      />
    </div>
  </a-modal>
</template>

<script setup>
import { inject, reactive, watch } from 'vue'
import { usePagination } from '@/utils/useCommon'
import { popupWindow_main_page } from '@/server/modules/51648'
import { message } from 'ant-design-vue'

const columns = [
  {
    title: '规则ID',
    key: 'ruleIdList',
    dataIndex: 'ruleIdList',
    ellipsis: true
  },
  {
    title: '间隔天数',
    dataIndex: 'intervalDays'
  },
  {
    title: '弹出次数',
    dataIndex: 'popupCount'
  },
  {
    title: '操作人',
    dataIndex: 'creatorUserName'
  },
  {
    title: '操作时间',
    dataIndex: 'gmtCreate'
  }
]

const state = reactive({
  pagination: usePagination(),
  dataSource: [],
  intervalDays: null,
  popupCount: null
})

const initState = inject('initState')

const onOk = () => {
  if (!state.intervalDays || !state.popupCount) {
    return message.warn('间隔天数和弹出次数不能为空')
  }
  initState.onOk({
    intervalDays: state.intervalDays,
    popupCount: state.popupCount
  })
}

const getMainPage = async (pageNum, pageSize) => {
  if (pageNum) {
    state.pagination.pageNum = pageNum
  }
  if (pageSize) {
    state.pagination.pageSize = pageSize
  }
  const params = {
    brandId: 1,
    channelId: 1,
    siteId: initState.siteId,
    terminalId: initState.terminalId,
    ...state.pagination
  }
  const { data } = await popupWindow_main_page(params)
  state.dataSource = data.list
  state.pagination.total = data.total
}

watch(
  () => initState.visible,
  value => {
    if (value) {
      getMainPage()
    } else {
      state.intervalDays = null
      state.popupCount = null
    }
  }
)
</script>
<style scoped>
.pagination {
  display: flex;
  flex-direction: row-reverse;
  background: #fff;
  padding: 20px;
}
</style>
